import type { SimulationConfig } from '../../config/schema';
import type { Controls } from '../Controls';
import type { ZoomController } from '../ZoomController';

export interface ControlSetupContext {
  config: SimulationConfig;
  controls: Controls;
  zoomController: ZoomController;
  markStale: () => void;
  syncUI: () => void;
  regenerateTiling: () => void;
  handleSystemChange: () => void;
  applyAxisDefaults: (axis: 'x' | 'y') => void;
  resetZoom: () => void;
}

export function bindRangeParam(
  ui: Controls,
  id: string,
  valueId: string,
  apply: (v: number) => void,
  fmt: (v: number) => string,
): void {
  ui.bindControl(id, (v) => {
    const n = parseFloat(v);
    apply(n);
    ui.setText(valueId, fmt(n));
  });
}
